import React, { useState , useEffect,} from 'react';
import './App.css';
import { MantineProvider } from '@mantine/core';

import { collection, doc ,getDoc , serverTimestamp,
  updateDoc, setDoc } from 'firebase/firestore';
import { db, auth } from './firebase';
import { getAnalytics, logEvent } from "firebase/analytics";

// import LoadingButton from '@mui/lab/LoadingButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { Container, Typography, Grid , IconButton, CircularProgress, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import {LightMode} from '@mui/icons-material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { getFunctions, httpsCallable } from "firebase/functions";

import { onAuthStateChanged,signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { DarkMode } from '@mui/icons-material';


import axios from 'axios';

import WordBox from './components/WordBoxCom';
import NoWordsSnackbar from './components/NoWordsSnack';
import WordsSnackbar from './components/WordsSnackbar';
import SentencesSnackbar from './components/SentencesSnackbar';
import AddedMailSnackbar from './components/AddedMailSnackbar';
import NonValidEmailSnackbar from './components/NonValidEmailSnackbar';
import InfoModal from './components/InfoModal';
import MobileModal from './components/MobileModal';
import WelcomeModal1 from './components/WelcomeModal1';
import WelcomeModal2 from './components/WelcomeModal2';
import TopGridComponent from './components/TopGridComponent';

const provider = new GoogleAuthProvider();
const analytics = getAnalytics();

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
  borderRadius: 3
};

function App() {

  const functions = getFunctions();

  const [words, setWords] = useState([]);
  const [newWord, setNewWord] = useState('');

  const [checkedWordsIndex, setCheckedWordsIndex] = useState([]);
  const [checkedWords, setCheckedWords] = useState([]);

  const [text, setText] = useState(`Press one of the buttons above 👆`);
  const [result, setResult] = useState('');
  const [loadingRandomGPT, setloadingRandomGPT] = useState(false);
  const [loadingChosenGPT, setloadingChosenGPT] = useState(false);

  const [userSignedIn, setUserSignedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [isDarkMode, setDarkMode] = useState(true)
  const [curUser,setCurUser] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);  

  const [signUpAlertGPT, setSignUpAlertGPT] = useState(false);
  const [signUpAlertWords, setSignUpAlertWords] = useState(false);
  const [numberOfAccessedGPT,setNumberOfAccessedGPT] = useState(0);

  const [noWordAlert,setNoWordAlert] = useState(false);

  const [isMobile, setIsMobile] = useState(false)
  const [emailForUpdates,setEmailForUpdates] = useState('');
  const [emailAddedToList,setEmailAddedToList] = useState(false)
  const [emailAddedToListError,setEmailAddedToListError] = useState(false)

  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);

  const dynamicText = "This is some dynamically generated text containing important keywords.";
  const targetWords = ["important", "keywords"]; // Add any target words you want to make bold

  const handleCloseModal1 = () => {
    setOpenModal1(false);
    setOpenModal2(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal2(false);
  };

  const handleCloseAlertWords = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSignUpAlertWords(false);
  };

  const handleCloseNoWordAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setNoWordAlert(false);
  };

  const handleCloseAlertGPT = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSignUpAlertGPT(false);
  };

  const handleCloseEmailAddedToList = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setEmailAddedToList(false);
  };

  const handleCloseEmailAddedToListError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setEmailAddedToListError(false);
  };

  const handleInfoOpen = () => {
    setInfoOpen(true);
    logEvent(analytics,'open_info',{
      user: curUser,
      timeStamp: serverTimestamp()
    })
  };

  const handleInfoClose = () => {
    setInfoOpen(false);
  };

  const darkTheme = createTheme({
    palette: {
      mode:'dark',
    },
  });

  const lightTheme = createTheme({
    palette: {
      mode:'light',
    },
  });

  const toggleTheme = () => {
    setDarkMode(isDarkMode => !isDarkMode);
    logEvent(analytics,'toggle_darkmode',{
      user: curUser,
      is_dark_mode: isDarkMode,
      timeStamp: serverTimestamp()
    })
  }

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, user => {
      console.log('onAuthStateChanged');
      // console.log(user)
      if(user == null) {
        console.log('NO USER!');
        if(!isMobile){
          setOpenModal1(true);
        }
      }
      else {
        console.log(user.displayName.split(" ")[0]);
        setUserSignedIn(true);
        setUserName(user.displayName.split(" ")[0]);
        setCurUser(user);
        fetchWords(user);
        // clear chosen words (index and words)
        setCheckedWords([]);
        setCheckedWordsIndex([]);
      }
    });
    return () => {
      unsubscribe(); // Unsubscribe the listener when the component unmounts
    };
  },[]);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful
        console.log('User signed out successfully.');
        setUserSignedIn(false);
        setUserName('Guest');
        setCurUser(null);
        // setWords(['Some','Generic','Vocabulary']);
        setWords(words);

      })
      .catch((error) => {
        // An error occurred
        console.error('Error signing out:', error.message);
      });
      // clear chosen words (index and words)
      setCheckedWords([]);
      setCheckedWordsIndex([]);
  };

  useEffect(() => {
    const getDevice = () => {
      const userAgent = window.navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const tabletRegex = /iPad|Android/i;

      if (mobileRegex.test(userAgent)) {
        console.log('Device - Mobile');
        setIsMobile(true);
      } else if (tabletRegex.test(userAgent)) {
        console.log('Device - Tablet');
      } else {
        console.log('Device - Desktop');
      }

      
    };

    getDevice();
  }, []);

  const handleSignIn = async () => {

    logEvent(analytics,'handle_signin',{
      user_random_number: 5,
      timeStamp: serverTimestamp()
    })

    signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      // const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...
      const isNewUser = user.metadata.creationTime === user.metadata.lastSignInTime;
      // console.log('IS NEW USER?');
      // console.log(isNewUser);
      // console.log(`user.metadata.creationTime: ${user.metadata.creationTime}`)
      // console.log(`user.metadata.lastSignInTime: ${user.metadata.lastSignInTime}`);
      const currentWords = words;
      if (isNewUser) {
        // Save user data to Firestore
        //db.collection('users').doc(user.uid).set({ displayName: user.displayName, email: user.email });
        setDoc(doc(db, "users", user.uid), {
          displayName: user.displayName,
          email: user.email,
          // words: ['Your','Words'],
          words: currentWords,
          creationTime: user.metadata.creationTime,
          lastSignInTime: user.metadata.lastSignInTime,
        });
        console.log('New user signed up successfully!');
      } else {
        console.log('Existing user logged in!');
        fetchWords(user);
        
        updateDoc(doc(db, "users", user.uid), {
          lastSignInTime: user.metadata.lastSignInTime,
        }, { merge: true });
      }
      // clear chosen words (index and words)
      setCheckedWords([]);
      setCheckedWordsIndex([]);
    }).catch((error) => {
      // Handle Errors here.
      console.error(error);
    });
  }

  const fetchWords = async (user) => {
    console.log('fetchWords !!!')
    try {
      if(user) {
        const ref = doc(db,'users',user.uid);
        const docSnap = await getDoc(ref);

        if (docSnap.exists()) {
          setWords(docSnap.data().words)
        } else {
          console.log("No such document!");
        }
      } else {
        console.log('No user - No fetch!');
      }
    
    } catch (error) {
      console.error('Error fetching words:', error);
    }
  };

  const updateWordsInFirestore = async (newWords) => {
    try {
      if(userSignedIn){
        const collectionRef = collection(db, 'users');
        const userDocRef = doc(collectionRef, curUser.uid);
        if(words.length !== 0 ){        
          await updateDoc(userDocRef, { words: newWords });
          // console.log(words)
        }
        console.log('Words updated in Firestore');
      } else {
        // const collectionRef = collection(db, 'voc-squire1');
        // const userDocRef = doc(collectionRef, 'user1');
        // if(words.length != 0 ){        
        //   await updateDoc(userDocRef, { words: words });
        // }
        console.log('No user - No update');
      }
    } catch (error) {
      console.error('Error updating words:', error);
    }
  };

  const callFirebaseFunction = async () => {

    if(!curUser && numberOfAccessedGPT>2){
      setSignUpAlertGPT(true);
      return
    }
    setNumberOfAccessedGPT(numberOfAccessedGPT + 1);

    setloadingRandomGPT(true);
    const randomIndex = Math.floor(Math.random() * words.length);
    const randomWord = words[randomIndex];

    const callGPT = httpsCallable(functions, 'callGPT');
    callGPT({ word: randomWord.word, text: 'text' })
      .then((result) => {
        // console.log(result.data.textGPT);
        setResult(result.data.textGPT);
        setloadingRandomGPT(false);
        logEvent(analytics,'random_GPT',{
          user: curUser,
          the_word: randomWord,
          result: result.data.textGPT,
          timeStamp: serverTimestamp()
        })
      });
  };

  const callChosenFirebaseFunction = async () => {

    if(!curUser && numberOfAccessedGPT>2){
      setSignUpAlertGPT(true);
      return
    }

    setNumberOfAccessedGPT(numberOfAccessedGPT + 1);
    setloadingChosenGPT(true);

    // now that each word in a json object, need to 
    const theWords = checkedWords.map(wordObj => wordObj.word)

    const callGPT_multiply_words = httpsCallable(functions, 'callGPT_multiply_words');
    callGPT_multiply_words({ words: theWords, text: 'text' })
      .then((result) => {
        console.log(result.data.textGPT);
        setResult(result.data.textGPT);
        setloadingChosenGPT(false);
        logEvent(analytics,'chosen_GPT',{
          user: curUser,
          the_words: checkedWords,
          result: result.data.textGPT,
          timeStamp: serverTimestamp()
        })
      });
  };

  const handleAddWord = async () => {

    if(newWord === ''){
      return
    }

    try{

    const resp = await axios.get(`https://api.dictionaryapi.dev/api/v2/entries/en/${newWord}`);
    const wordObject = resp.data[0];

    if (newWord.trim() !== '') {
      if(!curUser && words.length >= 5){
        console.log('Please sign in to store more than 3 words')
        setSignUpAlertWords(true)
      }
      else {
        if(words){
          setWords([...words, wordObject]);
        }
        else{
          setWords(wordObject);
        }
        setNewWord('');
        if(curUser){
          await updateWordsInFirestore([...words, wordObject]);
        }
        logEvent(analytics,'add_word',{
          user: curUser,
          added_words: newWord,
          words_before : words,
          timeStamp: serverTimestamp()
        })
      }
    }
    } catch (error) {

      console.log(error.message)
      if(error.message === 'Request failed with status code 404'){
        console.log('NOT FOUND')
        setNoWordAlert(true);
      }

    }
  };
  

  const handleRemoveWord = (index) => {
    const updatedWords = [...words];
    const the_word = words[index];
    const updatedCheckedWords = [...checkedWords];
    const index_of_checked_word = updatedCheckedWords.indexOf(the_word);
    console.log(`Removing the word: ${the_word}`)

    console.log(`index = ${index}`);

    if(checkedWords.includes(the_word)) {
      console.log(`index_of_checked_word = ${index_of_checked_word}`);
      updatedCheckedWords.splice(index_of_checked_word,1);

    }

    updatedWords.splice(index, 1);
    setWords(updatedWords);
    if(curUser){
      updateWordsInFirestore(updatedWords);

    }
    const indices = updatedCheckedWords.map(word => updatedWords.indexOf(word));

    // console.log(`updatedCheckedWords = ${updatedCheckedWords}`);
    // console.log(updatedCheckedWords)

    // console.log(`indices = ${indices}`);
    // console.log(indices)

    setCheckedWords(updatedCheckedWords);
    setCheckedWordsIndex(indices)

    logEvent(analytics,'remove_word',{
      user: curUser,
      removed_word: the_word,
      timeStamp: serverTimestamp()
    })

       
  };

  const handleToggleCheck = (index) => {
    console.log('handleToggleCheck. word:')
    const the_word = words[index]
    console.log(the_word)
    console.log('checkedWordsIndex');
    console.log(checkedWordsIndex);
    if (checkedWordsIndex.includes(index)) {
      setCheckedWordsIndex(checkedWordsIndex.filter((wordIndex) => wordIndex !== index));
      setCheckedWords(checkedWords.filter((word) => word !== the_word));

    } else {
      setCheckedWordsIndex([...checkedWordsIndex, index]);
      setCheckedWords([...checkedWords, the_word]);
    }

    // add or remove word
    // if (checkedWords.includes(word)) {
    //   // String is already in the array, so remove it
    //   checkedWords = checkedWords.filter(item => item !== word);
    // } else {
    //   // String is not in the array, so add it
    //   checkedWords.push(word);
    // }
    console.log('checkedWords:');
    console.log(checkedWords);
    console.log('checkedWordsIndex:');
    console.log(checkedWordsIndex);
  };

  const keyPress = (e) => {
    if(e.keyCode === 13){
       console.log('value', e.target.value);
       // put the login here
       handleAddWord()
    }
 }

 const keyPressEmail = (e) => {
  if(e.keyCode === 13){
     console.log('value', e.target.value);
     // put the login here
     handleSignUpForUpdates()
  }
}

  const isValidEmail = (email) => {
    return  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

 const handleSignUpForUpdates = () => {
  if(emailForUpdates === '') {
    console.log('empty string')
    return
  }
  if(isValidEmail(emailForUpdates)){
    setDoc(doc(db, "email_list", emailForUpdates), {
      email: emailForUpdates,
      // words: ['Your','Words'],
      time: serverTimestamp(),
      valid_email: true,
      mobile: isMobile
  
    });
    setEmailAddedToList(true);
  }
  else {
    // setEmailForUpdates('NOT VALID EMAIL!')
    setEmailAddedToListError(true)
    setDoc(doc(db, "email_list", emailForUpdates), {
      email: emailForUpdates,
      // words: ['Your','Words'],
      time: serverTimestamp(),
      valid_email: false,
      mobile: isMobile
  
    });
  }

 }

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
    <CssBaseline />

      <Container maxWidth="lg" sx = {{p:5,}}>
      <TopGridComponent  userSignedIn={userSignedIn} handleSignOut={handleSignOut} handleSignIn={handleSignIn} userName={userName} toggleTheme={toggleTheme} isDarkMode={isDarkMode} handleInfoOpen={handleInfoOpen}  />
      
      {false &&
      <Box display="flex" sx ={{boxShadow:8, borderRadius:5}}>
        <Box flex="1" padding={2}>
          {/* Content for the left column */}
          <Grid container justifyContent="left" alignItems="center" >
          <Grid item xs={15}  sx={{textAlign: 'left' , background:'red'}}>
            <Typography variant="h5" component="h2" fontFamily="Raleway"  gutterBottom>
              Your words:
            </Typography>
          <Box className="left-column">
          <Box className="input-container">
            <TextField
              inputProps={{
                style:{fontFamily:"Raleway"}
              }}
              type="text"
              value={newWord}
              onChange={(e) => setNewWord(e.target.value)}
              placeholder="Enter a word"
              onKeyDown={keyPress}
            />
            <Button 
              onClick={handleAddWord} 
              variant="contained" 
            >
                Add
            </Button>
          </Box>

          <Box >
            <Stack  
            spacing={{ xs: 1, sm: 1 }}
            direction="row"
            useFlexGap
            flexWrap="wrap" 
            >
            {words &&  words.map((word, index) => (
                <WordBox checked={checkedWordsIndex.includes(index)}  index={index} word={word} handleRemoveWord={handleRemoveWord} handleToggleCheck={handleToggleCheck}  />
              ))} 
            </Stack>
          </Box>
          </Box>
          </Grid>
          

        </Grid>
        
        </Box>
      <RightColumn   loadingChosenGPT={loadingChosenGPT} callChosenFirebaseFunction={callChosenFirebaseFunction} loadingRandomGPT={loadingRandomGPT} callFirebaseFunction={callFirebaseFunction} result={result} text={text}  />
      </Box>
      }
      
      <Grid display='flex' container sx={{ justifyContent:'center'}}>
        <Grid display='flex' className='left-menu' sx={{width:'10%',mt:1,mb:1,border:'1px solid' ,borderColor:'#ddd',
              borderRadius:2, flexDirection:'column'}}>
          <Typography variant='h4' align='center' sx={{fontFamily:"Raleway"}}>
            Menu
          </Typography>
          <Typography align='center' text sx={{fontFamily:"Raleway"}}>
            <i>Coming soon!</i>
          </Typography>
          
          {/* <Typography>normal text <strong>bold text</strong> normal text</Typography> */}
          <FormGroup sx={{ alignContent:'center'}}>
            <FormControlLabel disabled control={<Checkbox />} label="Label 1" />
            <FormControlLabel disabled control={<Checkbox />} label="Label 2" />
          </FormGroup>
        </Grid>
        <Grid display='flex' container className='words-grid' sx={{m:1,width:'60%', border:'0px solid' ,borderColor:'#ddd',
              borderRadius:2,
                  }}>
            <Grid container className='words-top' sx={{height:200, width:'100%'}}>
        
              <Grid className='words-menu' container alignItems="center"
              sx={{display: 'flex', minHeight:'200',
              direction:'column',justifyContent: 'space-between'}}> 
                <Box sx={{width:'35%',display: 'flex', direction:'column', height:'100%',  
                    alignItems:'center',p:1}}>
                  <TextField
                    inputProps={{
                      style:{fontFamily:"Raleway"}
                    }}
                    type="text"
                    value={newWord}
                    onChange={(e) => setNewWord(e.target.value)}
                    placeholder="Enter a word"
                    onKeyDown={keyPress}
                    // sx = {{height:'60%'}}
                    size="small"
                    sx ={{mr:1}}

                  />
                  <Button 
                    onClick={handleAddWord} 
                    variant="contained" 
                    sx = {{height:'80%'}}
                  >
                      Add
                  </Button>
                </Box>
                
                <Box sx={{p:1}}>
                {!loadingRandomGPT && 
                  <Button sx={{ p: 1, mr:1 }} 
                    variant="outlined" 
                    onClick={callFirebaseFunction}>
                  Random 🪄
                  </Button>}
                  {loadingRandomGPT && <CircularProgress />}
                  {/* <LoadingButton
                    size="small"
                    // onClick={handleClick}
                    loading={loadingRandomGPT}
                    variant="outlined"
                    disabled
                  >
                    <span>disabled</span>
                  </LoadingButton> */}
                  {!loadingChosenGPT && <Button sx={{p: 1}} variant="contained" onClick={callChosenFirebaseFunction}>
            Build from ticked ✔️
          </Button>}
          {loadingChosenGPT && <CircularProgress />}

                </Box>
                
              </Grid>
              
              <Stack  
              sx= {{mt:0.5,p:0.5,}}
              spacing={{ xs: 1, sm: 1 }}
              direction="row"
              useFlexGap
              flexWrap="wrap" 

              >

              {words &&  words.map((word, index) => (
                <WordBox checked={checkedWordsIndex.includes(index)}  index={index} word={word} handleRemoveWord={handleRemoveWord} handleToggleCheck={handleToggleCheck}  />
              ))} 
   
              </Stack>
              <Box sx={{pt:0.5,pl:0.5, width:'100%'}}>
                
                 
                <Box className="right-column" alignItems="left">
                  {false &&
                  <Paper component="div" sx={{
                    whiteSpace: 'normal',
                    borderRadius: 5,
                    p: 1.5,
                    fontFamily: 'Raleway'
                  }}>
                  {/* <p> */}
                    {result ? result : text}
                  {/* </p>  */}
                  </Paper>
                  }
                  <MyComponent dynamicText={result} targetWords={checkedWords} />

                </Box>
              </Box>

            </Grid>
            {false && <Grid className='words-low' 
             sx={{height:200,m:1}}
             >
              <Typography>
                Text Field + Engagement
              </Typography>
              <Box className="right-column" alignItems="left">
                <Paper component="div" sx={{
                  whiteSpace: 'normal',
                  borderRadius: 5,
                  p: 1.5,
                  fontFamily: 'Raleway'
                }}>
                {/* <p> */}
                  <span>
                   {result ? result : text}
                  </span>
                {/* </p>  */}
                </Paper>

              </Box>
              {/* Add a box for starring for the text*/}
            </Grid>}
            
        </Grid>
      </Grid>
      
    </Container>

    
    <WordsSnackbar   signUpAlertWords={signUpAlertWords} handleCloseAlertWords={handleCloseAlertWords}  />
    <SentencesSnackbar   signUpAlertGPT={signUpAlertGPT} handleCloseAlertGPT={handleCloseAlertGPT}  />
    <AddedMailSnackbar   emailAddedToList={emailAddedToList} handleCloseEmailAddedToList={handleCloseEmailAddedToList} emailForUpdates={emailForUpdates}  />
    <NonValidEmailSnackbar   emailAddedToListError={emailAddedToListError} handleCloseEmailAddedToListError={handleCloseEmailAddedToListError} emailForUpdates={emailForUpdates}  />
    <NoWordsSnackbar noWordAlert={noWordAlert} handleCloseNoWordAlert={handleCloseNoWordAlert} theWord={newWord} />
    <InfoModal   infoOpen={infoOpen} handleInfoClose={handleInfoClose}  />
    <MobileModal   isMobile={isMobile} emailForUpdates={emailForUpdates} setEmailForUpdates={setEmailForUpdates} handleSignUpForUpdates={handleSignUpForUpdates}  />
    {!isMobile &&
      <WelcomeModal1   openModal1={openModal1} handleCloseModal1={handleCloseModal1} style={style}  />
    }
    <WelcomeModal2   openModal2={openModal2} handleCloseModal2={handleCloseModal2} style={style} emailForUpdates={emailForUpdates} setEmailForUpdates={setEmailForUpdates} keyPressEmail={keyPressEmail} handleSignUpForUpdates={handleSignUpForUpdates}  />

    </ThemeProvider>
    </MantineProvider>
  );
}



function RightColumn({loadingChosenGPT, callChosenFirebaseFunction, loadingRandomGPT, callFirebaseFunction, result, text}) {
  return (<Box flex="1" padding={2}>
      {
/* Content for the right column */
}
      <Box sx={{
flexDirection: 'row'
}}>
        <Box sx={{
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  p: 0.5
}}>
          <Typography variant='h5' sx={{
    justifyContent: 'center'
  }} fontFamily="Raleway">
            Practice - build a sentence!
          </Typography>
          
        </Box>

        <Stack direction="row" spacing={2} sx={{
  justifyContent: 'center',
  p: 1
}}>
          {!loadingChosenGPT && <Button sx={{
    p: 1
  }} variant="contained" onClick={callChosenFirebaseFunction}>
            Build from ticked ✔️
          </Button>}
          {loadingChosenGPT && <CircularProgress />}
          {!loadingRandomGPT && <Button sx={{
    p: 1
  }} variant="outlined" onClick={callFirebaseFunction}>
            Random 🪄
          </Button>}
          {loadingRandomGPT && <CircularProgress />}

        </Stack>
        
      </Box>
      <Box component="form" sx={{
'& .MuiTextField-root': {
  m: 1,
  width: '25ch'
}
}} noValidate autoComplete="off">
        <Box className="right-column" alignItems="left">
          <Paper component="div" sx={{
    whiteSpace: 'normal',
    borderRadius: 5,
    p: 1.5,
    fontFamily: 'Raleway'
  }}>
            {/* <p> */}
              {result ? result : text}
            {/* </p>  */}
          </Paper>
        </Box>
      </Box>
    </Box>);
}

const MyComponent = ({ dynamicText, targetWords }) => {
  const textArray = dynamicText.split(' ');
  const boldWords = targetWords.map(wordObj => wordObj.word)
  // const theWords = checkedWords.map(wordObj => wordObj.word)


  return (
    <Paper sx ={{
      whiteSpace: 'normal',
      borderRadius: 5,
      p: 1.5,
      fontFamily: 'Raleway'
    }}
    >
      {textArray.map((word, index) => {
        const isTargetWord = boldWords.includes(word.toLowerCase()); // Assuming targetWords is an array of lowercase words
        return isTargetWord ? <i><strong key={index}>{word} </strong></i> : <span key={index}>{word} </span>;
      })}
    </Paper>
  );
};

export default App;  

    